import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { getRawCollection } from '@adornis/baseql/server/collections.js';
import { Draft } from '../db/Draft.js';

/**
 * Ändert den zugewiesenen Bearbeiter eines Entwurfs.
 *
 * @throws {Error} Wenn der Entwurf nicht gefunden wird.
 */
export const changeAssignee = registerMutation({
  type: () => String,
  operationName: 'changeAssignee',
  resolve: (draftID: string, assigneeKey: 'assignedReviewer' | 'assignedDesigner', assigneeID?: string) => {
    return async () => {
      const rawDraftCollection = await getRawCollection<Draft>(Draft._collectionName);
      await rawDraftCollection.updateOne({ _id: draftID }, { $set: { [assigneeKey]: assigneeID ? assigneeID : null } });
    };
  },
  params: [
    { name: 'draftID', type: () => String },
    { name: 'assigneeKey', type: () => String },
    { name: 'assigneeID', type: () => String },
  ],
});
